import { Routes, Route } from "react-router-dom";
import Dashboard from "../components/pages/admin/Dashboard/Dashboard";
import Manageusers from "../components/pages/admin/Dashboard/Usermanagement";
import UserDetailsPage from "../components/pages/admin/Dashboard/Usermanagement/Userdetails";
import Managecampaigns from "../components/pages/admin/Dashboard/Manage_campaigns";
import Transactions from "../components/pages/admin/Dashboard/Transactions";
import Log from "../components/pages/admin/Dashboard/Log";
import Tickets from "../components/pages/admin/Dashboard/Tickets";
import AdminProtectedRoute from "../components/pages/admin/ProtectRoutes";
import AdminLogin from "../components/pages/admin/Login/Login";
import Register from "../components/pages/admin/Register/Register";
import ResetPassword from "../components/pages/admin/ResetPassword/ResetPassword";
import Setpassword from "../components/pages/admin/ResetPassword/Setpassword";
import ResetPasswordForm from "../components/pages/admin/ResetPassword/PasswordResetForm copy";
import ManageAdmins from "../components/pages/admin/Dashboard/Manageadmins";
import NewsletterManagement from "../components/pages/admin/Dashboard/Newsletter/Newsletter";
import ManageOrgs from "../components/pages/admin/Dashboard/Organisations";
import OrganizationDetailsPage from "../components/pages/admin/Dashboard/Organisations/OrganisationDetails";
import RecurringDonations from "../components/pages/admin/Dashboard/RecurringDonations";
import RecurringDonationDetails from "../components/pages/admin/Dashboard/RecurringDonations/RecurringDonationDetails";
import YambaCares from "../components/pages/admin/Dashboard/YambaCares";
import MembershipTransactions from "../components/pages/admin/Dashboard/MembershipTransactions";

function AdminRoutes() {
  return (
    <Routes>
      {/* Protected Routes */}
      <Route 
        path="/dashboard" 
        element={
          <AdminProtectedRoute>
<Dashboard />
          </AdminProtectedRoute>
        }
      />
      <Route 
        path="/users" 
        element={
          <AdminProtectedRoute>
<Manageusers />
          </AdminProtectedRoute>
        }
      />

      <Route 
        path="/newsletter" 
        element={
          <AdminProtectedRoute>
<NewsletterManagement />
          </AdminProtectedRoute>
        }
      />
      <Route 
        path="/user-details/:id" 
        element={
          <AdminProtectedRoute>
<UserDetailsPage />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="/campaigns"
        element={
          <AdminProtectedRoute>
<Managecampaigns />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="/yamba-cares"
        element={
          <AdminProtectedRoute>
<YambaCares />
          </AdminProtectedRoute>
        }
      />
      <Route 
        path="/transactions" 
        element={
          <AdminProtectedRoute>
<Transactions />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="/membership-transactions"
        element={
          <AdminProtectedRoute>
            <MembershipTransactions />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="/recurring-donations"
        element={
          <AdminProtectedRoute>
<RecurringDonations />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="/recurring-donations/:id"
        element={
          <AdminProtectedRoute>
<RecurringDonationDetails />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="/logs"
        element={
          <AdminProtectedRoute>
<Log />
          </AdminProtectedRoute>
        }
      />
      <Route 
        path="/tickets" 
        element={
          <AdminProtectedRoute>
<Tickets />
          </AdminProtectedRoute>
        }
      />
      <Route 
        path="/admins" 
        element={
          <AdminProtectedRoute>
<ManageAdmins />
          </AdminProtectedRoute>
        }
      />

      <Route 
        path="/organisations" 
        element={
          <AdminProtectedRoute>
<ManageOrgs />
          </AdminProtectedRoute>
        }
      />

      <Route 
        path="organization-details/:slug" 
        element={
          <AdminProtectedRoute>
            <OrganizationDetailsPage /> {/* Show the welcome notice only in protected routes */}
          </AdminProtectedRoute>
        }
      />


      {/* Unprotected Routes */}
      <Route path="/login" element={<AdminLogin />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ResetPassword />} />
      <Route path="/setpassword" element={<Setpassword />} />
      <Route path="/password-reset" element={<ResetPasswordForm />} />
    </Routes>
  );
}

export default AdminRoutes;
